import { Injectable } from '@angular/core';
import { GroupUI } from '@src/models';
import { BaseStoreService } from '@src/app/modules/base';

@Injectable({
  providedIn: 'root',
})
export class GroupsByUserStoreService extends BaseStoreService<GroupUI[]> {}
